export const RELATED_GAMES = {
  ACTION_TYPES: {
    relatedGamesMatchDetailsClick: 'relatedGamesMatchDetailsClick'
  },
}
